// Shared language list (codes match what the generator/backend expects).
export const supportedLanguages = [
    { code: 'spanish', name: 'Spanish' },
    { code: 'french', name: 'French' },
    { code: 'german', name: 'German' },
    { code: 'chinese-mandarin', name: 'Chinese (Mandarin)' },
    { code: 'japanese', name: 'Japanese' },
    { code: 'korean', name: 'Korean' },
    { code: 'italian', name: 'Italian' },
    { code: 'portuguese', name: 'Portuguese' },
    { code: 'russian', name: 'Russian' },
    { code: 'arabic', name: 'Arabic (Modern Standard)' },
    { code: 'dutch', name: 'Dutch' },
    { code: 'turkish', name: 'Turkish' },
    { code: 'vietnamese', name: 'Vietnamese' },
    { code: 'indonesian', name: 'Indonesian' },
    { code: 'hindi', name: 'Hindi' },
    { code: 'bengali', name: 'Bengali' },
    { code: 'japanese-kanji', name: 'Japanese (Kanji)' },
    { code: 'korean-honorific', name: 'Korean (Honorific)' },
    { code: 'thai', name: 'Thai' },
    { code: 'malay', name: 'Malay' },
    { code: 'polish', name: 'Polish' },
    { code: 'swedish', name: 'Swedish' },
    { code: 'danish', name: 'Danish' },
    { code: 'norwegian', name: 'Norwegian' },
    { code: 'finnish', name: 'Finnish' },
    { code: 'greek', name: 'Greek' },
    { code: 'czech', name: 'Czech' },
    { code: 'romanian', name: 'Romanian' },
    { code: 'ukrainian', name: 'Ukrainian' },
    { code: 'hebrew', name: 'Hebrew' },
    { code: 'persian', name: 'Persian (Farsi)' },
    { code: 'urdu', name: 'Urdu' },
    { code: 'swahili', name: 'Swahili' },
    { code: 'hungarian', name: 'Hungarian' },
    { code: 'bulgarian', name: 'Bulgarian' },
    { code: 'serbian', name: 'Serbian' },
    { code: 'croatian', name: 'Croatian' },
    { code: 'slovak', name: 'Slovak' },
    { code: 'lithuanian', name: 'Lithuanian' },
    { code: 'latvian', name: 'Latvian' },
    { code: 'estonian', name: 'Estonian' },
    { code: 'slovenian', name: 'Slovenian' },
    { code: 'macedonian', name: 'Macedonian' },
    { code: 'albanian', name: 'Albanian' },
    { code: 'georgian', name: 'Georgian' },
    { code: 'armenian', name: 'Armenian' },
    { code: 'azerbaijani', name: 'Azerbaijani' },
    { code: 'kazakh', name: 'Kazakh' },
    { code: 'uzbek', name: 'Uzbek' },
    { code: 'tamil', name: 'Tamil' },
    { code: 'telugu', name: 'Telugu' },
    { code: 'marathi', name: 'Marathi' },
    { code: 'gujarati', name: 'Gujarati' },
    { code: 'punjabi', name: 'Punjabi' },
    { code: 'malayalam', name: 'Malayalam' },
    { code: 'kannada', name: 'Kannada' },
    { code: 'odia', name: 'Odia' },
    { code: 'sinhala', name: 'Sinhala' },
];

export default supportedLanguages;
